<template>
<div>
    <Breadcrumb :title="'Distribution Upload'"></Breadcrumb>
    <div class="row no-gutters">

        <div class="col">
             <button class="btn btn-primary" style="float:right;" @click.prevent='downloadTemplate'><span class="fa fa-download"></span> Download Template</button>
             <button class="btn btn-secondary" style="float:right;margin-right:10px;" @click.prevent='backtoDistribution'>
                <span class="k-icon k-i-undo">  </span> &nbsp;Back to Distribution
                </button>
           
        </div>
    </div>
    <div class="row">
        <br>

</div>
        <BaseAuditDropzone :id="'Distribution'" ref="ParentFileUploaded" :acceptedFileTypes="SheetJSFT" @change="_change"  @Remove="ClearForm" :File="inputfile" :UploadType="FileUploadType"></BaseAuditDropzone>
        <br>
        <div ref="refCustomerror"
        id="Customerror"
        class="alert alert-danger"
        role="alert"
        v-show="pageErrors.length"
        >
        <span v-show="pageErrors.length" class="alert-danger">
            <b>Please correct the following error(s):</b>
            <ul>
            <li v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
        </span>
        </div>
        <br>
        <div v-show="displayPage">
        <div class="row no-gutters" >
            <div class="col">
                <div class="form-row">
                    <div class="col-md-12">
                        <BaseGrid :mode="'editform'" :config="DistributionUploadConfig" :data="dataDistributionExcel" @DeleteItem="DeleteDIfromGrid">
                            <!-- @EditItem="EditPartner"  -->
                        </BaseGrid>
                    </div>
                </div>
            </div>
        </div>
        
            <div class="row">
                <br>

</div>
                <div class="row no-gutters" style='float: right;margin-left:15px;'>
                    <button type="button" id="btnSave" :disabled="(!bValidated || pageErrors.length>0 || dataDistributionExcel.length<=0)" class="btn btn-primary" @click.prevent="SaveDistrubtions">Save</button>

                </div>
                <div class="row no-gutters" style='float: right;'>
                    <button type="button" id="btnSave" class="btn btn-secondary" @click.prevent="validateFn">Validate</button>
                </div>
                <div class="row">
                    <br><br>

</div>
                </div>

            </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import sheetJSConfig from "@/configs/sheetJS.js";
import XLSX from "xlsx";
import funcUtil from "@/services/funcUtil.js";
import axios from 'axios';
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BaseProgram from '@/models/BaseModelProgram.js';
import BasePartner from '@/models/BaseModelPartner.js';
import BaseModelDistribution from '@/models/BaseModelDistribution.js';
import {
    mapActions,
    mapState,
    mapGetters
} from 'vuex';
import {
    DistributionUploadConfig
} from './DistributionUploadConfig.js'
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import { isNullOrUndefined } from "util";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
    components: {
        BaseGrid,
        Breadcrumb,
        BaseAuditDropzone,
    },
    mixins: [apiUtil, funcUtil,DocumentManagerMixin],
    data() {
        return {
            data: "",
            inputfile: {
                UploadFile: {}
            },
            //UploadFile:excelfile,
            displayPage: false,
            FileUploadType: {
                AllowMultiple: "false"
            },
             SheetJSFT: sheetJSConfig.fileType,
            DistributionUploadConfig: DistributionUploadConfig,
            dataDistributionExcel: [],
            pageErrors: [],
            PartnerAPIData: [],
            ProgramAPIData: [],
            BaseModelInputControl:BaseModelInputControl,
            Columns:[],
            bValidated:false,
            bulkUploadAuditConfig: bulkUploadAuditConfig,
        };
    },
    computed: {
        $eumAuth: function(){
         return this.$root.$eumAuth;
        },
        ...mapState("postModule", ["response"]),
        ...mapGetters("getModule", ["getAllItemFilter","getLocalInputControls"]),
        ...mapGetters("authModule",["api_idtoken"])
    },
    methods: {
        ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
        _suppress(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        },
        downloadTemplate() {
             let token = this.api_idtoken;
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("DistributionExcel");
           let templateFileName = getFileName("DistributionExcel");
            
           axios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });
        },

        _drop(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            const files = evt.BaseModelTransfer.files;
            if (files && files[0]) this._file(files[0]);
        },
        _change(evt) {
            const files = this.inputfile.UploadFile[0];
            if (files) this._file(files);
        },
        backtoDistribution: function() {
      this.$router.push("/event/distribution");
        },
        _export(evt) {
            /* convert state to workbook */
            const ws = XLSX.utils.aoa_to_sheet(this.data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
            /* generate file and send to client */
            XLSX.writeFile(wb, "sheetjs.xlsx");
        },
        _file(file) {
            /* Boilerplate to set up FileReader */
            try {
                const self=this;
                const XLSX = require("xlsx");
                const reader = new FileReader();
                reader.onload = e => {
                    /* Parse data */
                    //const bstr = e.target.result;
                    let binary = "";
                    let bytes = new Uint8Array(e.target.result);
                    let length = bytes.byteLength;

                    for (let i = 0; i < length; i++) 
                    {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    const bstr = binary
                    const wb = XLSX.read(bstr, {
                        type: "binary"
                    });
                    /* Get Partner  data */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, {
                        range: sheetJSConfig.template.header - 1, 
                        header: 1
                    });
                    console.log(data);
                    data.splice(0, 1);
                    if (data && data.length) {
                        //get partner and Program
                        let response=this.getAllItemFilter({
                            Partner: {
                                config: BasePartner
                            },
                            Program: {
                                config: BaseProgram
                            }

                        });
                        if(response)
                        {
                            this.PartnerAPIData = response.Partner;
                            this.ProgramAPIData = response.Program;
                        }
                        //if (this.HeaderRow != "") {
                        this.displayPage = true;

                        var DistributionExcelArr = [];
                        var count = 1;
                        for (var i = 0; i < data.length; i++) {
                            var DistributionExcelObj = {};
                            DistributionExcelObj.DistributionKey = count++;
                            DistributionExcelObj.ProgramProgramID = !isNullOrUndefined(data[i][0])? data[i][0]: null;
                            DistributionExcelObj.PartnerPartnerID = !isNullOrUndefined(data[i][2])? data[i][2]: null;
                            DistributionExcelObj.DistributionAmount = !isNullOrUndefined(data[i][4])? data[i][4]: null;
                            DistributionExcelObj.DistributionType1 = !isNullOrUndefined(data[i][5])? this._firstLetterToUpper(data[i][5].toString().trim()): "";
                            DistributionExcelObj.DistributionType2 = !isNullOrUndefined(data[i][6])? this._firstLetterToUpper(data[i][6].toString().trim()): "";
                            DistributionExcelObj.DistributionPartnerType = !isNullOrUndefined(data[i][7])? this._firstLetterToUpper(data[i][7].toString().trim()): "";
                            DistributionExcelObj.DistributionDate = self._getExcelPlatformCode(data[i][8]);
            //                 moment(
            //     new Date(Math.round((data[i][8] - 25569) * 86400 * 1000))
            //   ).format("MM/DD/YYYY");
                            
                            DistributionExcelObj.Note = data[i][9];

                            DistributionExcelArr.push(DistributionExcelObj);
                        }
                        this.dataDistributionExcel = DistributionExcelArr;
                        this.getPartnerDetails();
                        this.getProgramDetails();

                        var grid = $("#DistributionUploadGrid").data("kendoGrid");

                        grid.dataSource.data(this.dataDistributionExcel);
                        console.log(JSON.stringify(this.dataDistributionExcel));
                    }
                    else{
                        this._AlertPopup("Template is Empty","error").then((result) => {
                        })
                    }

                    /* Update state */
                    //this.data = data;
                    //console.log(JSON.stringify(data));
                };
                reader.readAsArrayBuffer(file);
            } catch (ex) {
                console.log(ex);
                //this.$Progress.fail();
            }
        },
        getPartnerDetails: function () {
            let partner = this.PartnerAPIData.slice();
            let dataDistributionExcel = this.dataDistributionExcel.slice();

            for (let i = 0; i < dataDistributionExcel.length; i++) {
                if (dataDistributionExcel[i].PartnerPartnerID) {
                    var result = partner.filter(function (obj) {
                         if(obj.PartnerID){
                        return (obj.PartnerID.toString().trim().toLowerCase() == dataDistributionExcel[i].PartnerPartnerID.toString().trim().toLowerCase());
                        }

                    })[0];
                    if (result) {
                        dataDistributionExcel[i].PartnerTitle = result.FullName;
                        dataDistributionExcel[i].PartnerId=result.Id;
                    }
                }
            }

            this.dataDistributionExcel = dataDistributionExcel;

        },

        getProgramDetails: function () {
            let Program = this.ProgramAPIData.slice();
            let dataDistributionExcel = this.dataDistributionExcel.slice();

            for (let i = 0; i < dataDistributionExcel.length; i++) {
                if (dataDistributionExcel[i].ProgramProgramID) {
                    var result = Program.filter(function (obj) {
                       if(obj.ProgramID)
                        {
                        return (obj.ProgramID.toString().trim().toLowerCase() == dataDistributionExcel[i].ProgramProgramID.toString().trim().toLowerCase());
                        }
                    })[0];
                    if (result) {
                        dataDistributionExcel[i].ProgramTitle = result.Title;
                        dataDistributionExcel[i].ProgramId=result.Id;
                    }
                }
            }
            this.dataDistributionExcel = dataDistributionExcel;
        },

        DeleteDIfromGrid: function (e) {
            //e.preventDefault();
            //alert("Delete button clicked from BaseGrid..");
            
             const message = "Are you sure you want to delete this record?";
             this._ConfirmationPopup(message,"DELETE").then((result) => {
             if (result.value) {
           
                var gview = window.$("#DistributionUploadGrid").data("kendoGrid");
                var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
                //alert(JSON.stringify(dataItem));
                let objIndex = this.dataDistributionExcel.findIndex(
                    obj => obj.DistributionKey == dataItem.DistributionKey
                );
                this.dataDistributionExcel.splice(objIndex, 1);
                var grid = $("#DistributionUploadGrid").data("kendoGrid");
                grid.dataSource.data(this.dataDistributionExcel);
            }
        })
        },
        getConfirmation: function () {
            var retVal = confirm(
                "You are about to delete this Distribution.Press ok to continue otherwise press cancel."
            );
            if (retVal == true) return true;
            else return false;
        },

        getInputControls(){
            let self = this;
            let response = self.getLocalInputControls(self.BaseModelInputControl.list);

            this.DistributionType1Options=response.DistributionType1;
            this.DistributionType2Options=response.DistributionType2;
            this.DistributionPartnerTypeOptions=response.DistributionPartnerType;
        },

        SaveDistrubtions: function () {
            const self = this;
            // let distributionData=this.dataDistributionExcel;
            // distributionData.forEach(distribution => {
            //     distribution.DistributionDate=new Date(distribution.DistributionDate)
            // });
            let NewDistrubtionobject = {
                Distribution: {
                    config: BaseModelDistribution,
                    createData: this.dataDistributionExcel
                }
            };
             //let loader = this.$loading.show();
              self._APICrudPopup("APICrudpopup");
            //this._createAllItems(NewPartnerobject).then(addnewpartner => {
            this.CreateAllItems(NewDistrubtionobject).then(Distribution => {
                console.log(Distribution);
                //self._AlertPopup(" Distribution saved successfully", "success");
                 /** AUDIT DOCUMENT UPLOAD **/
            let FileUpload = [];
            let senderObj = {};
            //senderObj.Id = this.count++;
            let realfileName = this.inputfile.UploadFile[0].name;
            // senderObj.File = self._appendDatewithExcelName(fileName);
            senderObj.File = this.inputfile.UploadFile[0].upload.uuid
            senderObj.RealFileName = realfileName;
            senderObj.FileContent = this.inputfile.UploadFile[0];
            FileUpload.push(senderObj);
            this.UploadBulkAditFilesToDB(FileUpload)
                .then(response => {
                self._AlertPopup("Distribution saved successfully", "success");
                })
                .catch(error => {
                self._AlertPopup("Some Error Occurred!", "info");
                })
                .finally(() => {
                //loader.hide();
                });
            /** AUDIT DOCUMENT UPLOAD END */
            this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
                
            }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                //loader.hide();
            })
        },

        validateFn(e){
            let self = this;
            e.preventDefault();
            let dataItem = $("#DistributionUploadGrid").data("kendoGrid").dataSource.data();
            self.pageErrors=[];
            let errorMessages = new Set();
            self.bValidated=true;
            dataItem.forEach((ele,i) => {
                self.Columns = []
                //ProgramID validation
                let programIndex = self.ProgramAPIData.findIndex(f => f.ProgramID == ele.ProgramProgramID)
                if(ele.ProgramProgramID =="" || isNullOrUndefined(ele.ProgramProgramID) || programIndex < 0){
                    self.Columns.push({"column":"ProgramProgramID","row":i});
                    errorMessages.add("Program ID is Empty or Invalid")
                }
                //PartnerID
                let pIndex = self.PartnerAPIData.findIndex(f => f.PartnerID == ele.PartnerPartnerID)
                if(ele.PartnerPartnerID =="" || isNullOrUndefined(ele.PartnerPartnerID) || pIndex < 0){
                    self.Columns.push({"column":"PartnerPartnerID","row":i});
                    errorMessages.add("Partner ID is Empty or Invalid")
                }
                //Distribution Type 1
                let TaxYIndex = self.DistributionType1Options.findIndex(f => f.Option == ele.DistributionType1)
                if(ele.DistributionType1 =="" || isNullOrUndefined(ele.DistributionType1) || TaxYIndex < 0){
                    self.Columns.push({"column":"DistributionType1","row":i});
                    errorMessages.add("Distribution Type1 is Empty or Invalid")
                }
                //Distribution Type2
                let TaxQIndex = self.DistributionType2Options.findIndex(f => f.Option == ele.DistributionType2)
                if(ele.DistributionType2 =="" || isNullOrUndefined(ele.DistributionType2) || TaxQIndex < 0){
                    self.Columns.push({"column":"DistributionType2","row":i});
                    errorMessages.add("Distribution Type2 is Empty or Invalid")
                }
                //Distribution Partner Type
                let disPIndex = self.DistributionPartnerTypeOptions.findIndex(f => f.Option == ele.DistributionPartnerType)
                if(ele.DistributionPartnerType =="" || isNullOrUndefined(ele.DistributionPartnerType) || disPIndex < 0){
                    self.Columns.push({"column":"DistributionPartnerType","row":i});
                    errorMessages.add("Distribution Partner Type is Empty or Invalid")
                }
                //Distribution Date
                if(!(ele.DistributionDate instanceof Date && !isNaN(ele.DistributionDate.valueOf()))){
                    self.Columns.push({"column":"DistributionDate","row":i});
                    errorMessages.add("Distribution Date is Empty or Invalid")
                }
                //Distribution Amount
                if(isNaN(ele.DistributionAmount) || ele.DistributionAmount == null){
                    self.Columns.push({"column":"DistributionAmount","row":i});
                    errorMessages.add("Distribution Amount is Empty or Invalid")
                }
                self.Columns.push({"column":"Validation","row":i});
                self.ValidateImportData('DistributionUploadGrid',self.Columns)
            })
            self.pageErrors=[...errorMessages]
        },
        
        ClearForm() {    
            this.dataDistributionExcel=[]  
            this.displayPage = false;
            this.pageErrors=[];
            this.bValidated=false;
        },

    },

    mounted() {
        this.getInputControls();
    }
    
};
</script>

